import { Controller, useForm } from 'react-hook-form';
import { Button, Flex, TextAreaField, TextField } from '@aws-amplify/ui-react';
import { useUserQuery } from '../common/useUserQuery';
import { useFactsSheetPostMutation } from './api/useFactsSheetMutation';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const postFactsSheetRequest = z.object({
  sectionTitle: z
    .string({ message: 'Title is Required' })
    .min(1, { message: 'Title is Required' })
    .max(100, { message: 'Must be 100 or fewer characters long' }),
  sectionDescription: z
    .string({ message: 'Description is Required' })
    .min(1, { message: 'Description is Required' }),
});

const requiredValidations = postFactsSheetRequest.required();

export default function FactsSheetDetailsAdd({ onClose }) {
  const { data: userQueryData } = useUserQuery();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sectionTitle: '',
      sectionDescription: '',
    },
    resolver: zodResolver(requiredValidations),
  });
  const { mutate: factsSheetPostMutation } = useFactsSheetPostMutation();
  const onSubmit = (values) => {
    factsSheetPostMutation({
      type: 'GENERAL',
      patientUserId: userQueryData?.patientUserId,
      ...values,
    });
    reset();
    if (onClose) onClose();
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Controller
            name="sectionTitle"
            control={control}
            render={({ field }) => (
              <TextField
                width="100%"
                label="Section Title"
                placeholder="Section Title"
                {...field}
                errorMessage={errors.sectionTitle?.message}
                hasError={!!errors.sectionTitle}
              />
            )}
          />
          <Controller
            name="sectionDescription"
            control={control}
            render={({ field }) => (
              <TextAreaField
                width="100%"
                label="Section Description"
                placeholder="Section Description"
                {...field}
                errorMessage={errors.sectionDescription?.message}
                hasError={!!errors.sectionDescription}
              />
            )}
          />

          <Button variation="primary" type="submit">
            Save
          </Button>
        </Flex>
      </form>
    </>
  );
}
